import { receiveResults } from './results';
import { submitSearchRequest } from '../utils/api';

export const SUBMIT_QUERY = 'SUBMIT_QUERY';

function submitQuery(query) {
  return {
    type: SUBMIT_QUERY,
    query
  }
}

export function handleSubmitQuery(query) {
  return (dispatch) => {
    dispatch(submitQuery(query))
    return submitSearchRequest(query)
      .then((results) => {
        dispatch(receiveResults(results))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/query.js